<span [class.failed]="!item.success"> <i class="fas fa-circle mr-2"></i>{{ item?.action }} </span>
